import cx from 'classnames';
import { Panel } from 'mk2/components/Panel';
import React from 'react';
import styles from './PlanPanel.mscss';

interface OwnProps {
    headline?: string;
    description?: string | React.ReactNode;
    image?: any;
    imageFootnote?: string;
}

type Props = OwnProps;

const PlanPanel = React.memo<Props>(
    ({ headline, description, image, imageFootnote }) => {
        return (
            <Panel className={styles.PlanPanel}>
                {(headline || description) && (
                    <div
                        className={cx(image
                            ? styles.PlanPanel__headerWithImage
                            : styles.PlanPanel__headerWithoutImage,
                        )}
                    >
                        {headline && <h2 className={styles.PlanPanel__headline}>{headline}</h2>}
                        {description && <p className={styles.PlanPanel__description}>{description}</p>}
                    </div>
                )}
                {image && (
                    <div className={styles.PlanPanel__figure}>
                        {image}
                        {imageFootnote && (
                            <div className={styles.PlanPanel__footnote}>
                                * {imageFootnote}
                            </div>
                        )}
                    </div>
                )}
            </Panel>
        );
    },
);

PlanPanel.displayName = 'PlanPanel';

export default PlanPanel;
